import { Box, Stack, Typography } from '@mui/material';
import { useState, useEffect } from 'react';
import noFileImg from '/assets/image/no_file.svg';
import { StateCard } from '~/components/Global/Card';
import { FilterTab } from '~/components/Global/FilterTab';
import { useSelector } from 'react-redux';
import {
  getterFilterCollectionFiles,
  getterMyResourcesFiles,
} from '~/store/file/fileGetter';
import { FileCollection } from '~/types/enum';
import { RootState, useAppDispatch } from '~/store';
import { FileCard } from '~/components/Global/Card/FileCard';
import { CollectionFileDetail } from '~/store/file/file.type';
import {
  setFileCatalog,
  setFlashFiles,
  setOneBookFiles,
  setTikuFiles,
} from '~/store/file';
import { useFile } from '~/utils/hook/useFile';
import { isWeb } from '~/utils/helper/device';
import { FileListDownloadGroup } from '~/components/File/FileListDownloadGroup';
import { localFileEvent } from '~/tracking';

export const File = () => {
  const dispatch = useAppDispatch();
  const [currentTab, setCurrentTab] = useState(FileCollection.onebook);
  const [isLoading, setIsLoading] = useState(false);

  const getterFile =
    currentTab === FileCollection.resource
      ? getterMyResourcesFiles
      : getterFilterCollectionFiles;
  const FiltercollectionFiles = useSelector((state: RootState) =>
    getterFile(state, currentTab),
  );
  const isResource = !Array.isArray(FiltercollectionFiles);

  const isEmpty =
    (!isResource && FiltercollectionFiles.length === 0) ||
    (isResource && Object.keys(FiltercollectionFiles).length === 0);

  // 108課綱電子書、Flash 電子書、題庫的 Filter 是根據 fileName 去篩的
  // 我的資源是透過 fileCatalog 各個 subject, education, year 去篩的
  const {
    getOneBookFiles,
    getTikuFiles,
    getFileCatalog,
    getFlashFiles,
    reloadMyCDCase,
    fileCatalogChangeListener,
    oneBookFilesChangeListener,
    flashFilesChangeListener,
    tikuFilesChangeListener,
  } = useFile();

  useEffect(() => {
    if (isWeb) return;
    const loadFiles = async () => {
      try {
        setIsLoading(true);
        const oneBookFiles = await getOneBookFiles();
        dispatch(setOneBookFiles(oneBookFiles));
        const tikuFiles = await getTikuFiles();
        dispatch(setTikuFiles(tikuFiles));
        const flashFiles = await getFlashFiles();
        dispatch(setFlashFiles(flashFiles));
        const fileCatalog = await getFileCatalog();
        dispatch(setFileCatalog(fileCatalog));
        reloadMyCDCase(async () => {
          const reloadOneBookFiles = await getOneBookFiles();
          dispatch(setOneBookFiles(reloadOneBookFiles));
          const reloadTikuFiles = await getTikuFiles();
          dispatch(setTikuFiles(reloadTikuFiles));
          const reloadFlashFiles = await getFlashFiles();
          dispatch(setFlashFiles(reloadFlashFiles));
          const reloadFileCatalog = await getFileCatalog();
          dispatch(setFileCatalog(reloadFileCatalog));
        });
      } finally {
        setIsLoading(false);
      }
    };

    void loadFiles();

    // 監聽檔案準備狀態
    // const handleFilePrepare = async (isPreparing: boolean) => {
    //   console.log('hanfleFilePrepare', isPreparing)
    //   setIsLoading(isPreparing);
    //   if (!isPreparing) {
    //     await loadFiles(); // 重新讀取檔案
    //   }
    // };

    // window.api.on('filePrepareListener', ([event]) => {
    //   console.log('listen--------------', event)
    //   void handleFilePrepare(event as boolean);
    // });
  }, []);

  useEffect(() => {
    (() => {
      oneBookFilesChangeListener(oneBookFiles => {
        dispatch(setOneBookFiles(oneBookFiles));
      });
      tikuFilesChangeListener(tikuFiles => {
        dispatch(setTikuFiles(tikuFiles));
      });
      flashFilesChangeListener(flashFiles => {
        dispatch(setFlashFiles(flashFiles));
      });
      fileCatalogChangeListener(fileCatalog => {
        dispatch(setFileCatalog(fileCatalog));
      });
    })();
  }, []);

  return (
    <>
      <FilterTab
        tabs={Object.values(FileCollection)}
        currentTab={currentTab}
        setCurrentTab={setCurrentTab}
        onTabChange={tab => {
          localFileEvent({
            tab_name: `切換頁籤_${tab}`,
            category: tab,
          });
        }}
      />
      {isResource && (
        <Box sx={{ width: '100%' }}>
          {Object.entries(FiltercollectionFiles).map(([label, content]) => {
            return (
              <Box key={label}>
                <Typography
                  variant="h5"
                  sx={{ margin: '8px 24px', color: '#837300' }}
                >
                  {label}
                </Typography>
                <Stack
                  direction="row"
                  alignItems="flex-start"
                  flexWrap="wrap"
                  gap={2}
                >
                  <FileListDownloadGroup
                    lists={content}
                    key={label}
                    resource1={label}
                  />
                </Stack>
              </Box>
            );
          })}
        </Box>
      )}
      {!isResource && FiltercollectionFiles.length > 0 && (
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '16px',
            width: '100%',
            pt: '4px',
            pb: '16px',
          }}
        >
          {currentTab !== FileCollection.resource &&
            (
              FiltercollectionFiles as CollectionFileDetail<typeof currentTab>[]
            ).map(({ fileName, img, key, exePath, folderPath }) => (
              <FileCard
                key={key}
                fileName={fileName}
                img={img}
                exePath={exePath}
                type={currentTab}
                folderPath={folderPath}
                onOpen={() => {
                  localFileEvent({
                    tab_name: '開啟檔案',
                    category: currentTab,
                  });
                }}
              />
            ))}
        </Box>
      )}
      {(isEmpty || isLoading) && (
        <StateCard
          imgSrc={noFileImg}
          title="目前尚無任何檔案"
          content={
            isLoading
              ? '正在檔案準備中...'
              : '請前往「取得資源」找尋想要的資源吧！'
          }
        />
      )}
    </>
  );
};
